import { webba } from 'webba-id-sdk'

// Single-app SPA: use the singleton, configure once at module load.
// storagePrefix isolates tokens to this app in localStorage so other Webba
// apps on the same origin (none today, but future-proof) don't collide.
let configured = false

export function configureWebba(): void {
  if (configured) return
  webba.configure({
    appKey: import.meta.env.VITE_WEBBA_APP_KEY,
    redirectUri: window.location.origin + '/auth/callback',
    storagePrefix: 'stark',
  })
  configured = true
}

export { webba }
